export default __webpack_public_path__ + "static/media/discordJoin.fcbe404a.wav";